import { handleActions } from "redux-actions";

import { getLanguages } from "./actions";

const initialState = {
    isLoadingLanguages: false,
    languages: {},
    codes: []
};

export const languagesReducer = handleActions(
    {
        [getLanguages]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
